<!-- Bottom-center toasts (success, success-undo, error) -->
<div class="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-col gap-2">
  @for (toast of toastService.toasts(); track toast.id) {
    @if (toast.type !== 'success-link') {
    <div
      class="flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg animate-slide-up border-[3px]"
      [ngClass]="{
          'bg-green-50 border-green-50': toast.type === 'success' || toast.type === 'success-undo',
          'bg-red-50 border-red-50': toast.type === 'error'
        }"
      (mouseenter)="onMouseEnter(toast)"
      (mouseleave)="onMouseLeave(toast)">
      <!-- Icon -->
      @if (toast.type === 'success' || toast.type === 'success-undo') {
      <!-- Circled Check Icon -->
      <svg class="h-6 w-6 text-green-500 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      } @else if (toast.type === 'error') {
      <!-- Circled X Icon -->
      <svg class="h-6 w-6 text-red-500 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <path d="M15 9l-6 6M9 9l6 6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      }

      <!-- Message -->
      <span class="text-sm font-medium flex-1" style="color: #334155;">
        {{ toast.message }}
      </span>

      <!-- Undo Button (only for success-undo type) -->
      @if (toast.type === 'success-undo') {
      <button (click)="onUndo(toast)"
        class="px-3 py-1 text-sm font-medium text-green-600 hover:bg-green-50 rounded transition-colors cursor-pointer flex-shrink-0"
        type="button">
        Undo
      </button>
      }

      <!-- Close Button -->
      <button (click)="onClose(toast)"
        class="flex-shrink-0 p-1.5 rounded hover:bg-black/5 transition-colors cursor-pointer ml-auto" [ngClass]="{
            'text-green-500': toast.type === 'success' || toast.type === 'success-undo',
            'text-red-500': toast.type === 'error'
          }" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd" />
        </svg>
      </button>
    </div>
    }
  }
</div>

<!-- Top-right clickable toasts (success-link) -->
<div class="fixed top-6 right-6 z-[9999] hidden md:flex flex-col gap-2">
  @for (toast of toastService.toasts(); track toast.id) {
    @if (toast.type === 'success-link') {
    <div class="bg-white rounded-xl shadow-lg border border-grey-100 animate-slide-down p-3 cursor-pointer hover:bg-grey-50 transition-colors"
      style="min-width: 18rem; max-width: 22rem;"
      (click)="onClick(toast)"
      (mouseenter)="onMouseEnter(toast)"
      (mouseleave)="onMouseLeave(toast)">
      <div class="flex items-center gap-3">
        <!-- Status icon -->
        <div class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-green-50">
          <span class="pi pi-check text-green-600 text-base"></span>
        </div>
        <!-- Text -->
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-grey-900 truncate">{{ toast.message }}</p>
          <p class="text-xs leading-none mt-1 text-green-600">View plan</p>
        </div>
        
      </div>
    </div>
    }
  }
</div>